<template>
    <div class="main">
        <div class="header"></div>
        <div class="arm"></div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        };
    }
};
</script>

<style lang="stylus" scoped>
@keyframes header
    0%,45%
        transform rotate(0deg)
    55%
        transform rotate(10deg)
    60%,100%
        transform rotate(0deg)
@keyframes arm
    0%,30%
        transform rotate(0)
    90%,100%
        transform rotate(50deg)
.main
    size 3rem 2.68rem
    background url('/img/xj/fankuan_body.png') 0 0/100% 100% no-repeat
    .header
        position absolute
        left 1.6rem
        top -.1rem
        size .92rem .7rem
        background url('/img/xj/fankuan_head.png') 0 0/100% 100% no-repeat
        animation header 8s infinite linear
    .arm
        size 1.23rem 1.28rem
        position absolute
        right 0.55rem
        top .75rem
        background url('/img/xj/fankuan_arm.png') 0 0/100% 100% no-repeat
        animation arm 4s infinite linear alternate
        transform-origin 1.1rem .3rem
</style>
